module.exports = __webpack_public_path__ + "static/img/seminariocamara.6b3223f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/seminariocamara.svg
// module id = aU2T
// module chunks = 0